module.exports = __webpack_public_path__ + "img/1.89fa0514.png";